import React from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@material-ui/core";

const ViewReconcileHistory = ({
  reconcileHistoryData,
  openPopup,
  setOpenPopup,
}) => {
  const {
    payment_id,
    payment_type,
    check_number,
    deposit_date,
    reconciled_date,
    reconciled_by_user,
    reconciled_status,
    reconcile_id,
  } = reconcileHistoryData;

  const convertIsoDateStringToReglarDateString = (dateString) => {
    if (dateString === "") return "";
    if (dateString === "0001-01-01T00:00:00") return "";

    const bits = dateString.substring(0, 10).split("-");
    // biits [0] = year bits[1] = month bits[2] = day
    const formattedDate = `${bits[1]}/${bits[2]}/${bits[0]}`;
    return formattedDate;
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          style={{
            border: "1px solid black",
            borderCollapse: "collapse",
            width: "800px",
          }}
        >
          <TableHead style={{ backgroundColor: "InfoBackground" }}>
            <TableRow>
              <TableCell>Payment Id</TableCell>
              <TableCell>Payment Type</TableCell>
              <TableCell>Check Nbr</TableCell>
              <TableCell>Deposit Date</TableCell>
              <TableCell>Reconciled Date</TableCell>
              <TableCell>Reconciled By</TableCell>
            </TableRow>
          </TableHead>
          {reconciled_status === "reconciled" && (
            <TableBody>
              <TableRow>
                <TableCell>{payment_id}</TableCell>
                <TableCell>{payment_type}</TableCell>
                <TableCell>{check_number}</TableCell>
                <TableCell>
                  {convertIsoDateStringToReglarDateString(deposit_date)}
                </TableCell>
                <TableCell>
                  {convertIsoDateStringToReglarDateString(reconciled_date)}
                </TableCell>
                <TableCell>{reconciled_by_user}</TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <div
        style={{
          width: "800px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          color="primary"
          variant="contained"
          style={{
            width: "80px",
            height: "20px",
            fontSize: "0.8rem",
            padding: "8px",
            margin: "10px",
          }}
          onClick={() => {
            setOpenPopup(false);
          }}
        >
          Close
        </Button>
      </div>
    </>
  );
};

export default ViewReconcileHistory;
